import {createSlice, PayloadAction} from "redux-starter-kit";
import {Step} from "../WizardMap";

type NavigationState = {
    visitedSteps: Step[];
    journeySuccessful: boolean;
};

const initialNavigation: NavigationState = {
    visitedSteps: [],
    journeySuccessful: false
};

const navigationSlice = createSlice({
    slice: "navigation",
    initialState: initialNavigation,
    reducers: {
        addVisitedStep(state, action: PayloadAction<Step>) {
            state.visitedSteps = [...state.visitedSteps, action.payload];
        },
        toggleJourneySuccessful(state) {
            state.journeySuccessful = !state.journeySuccessful;
        }
    }
});

export const {
    addVisitedStep,
    toggleJourneySuccessful
} = navigationSlice.actions;

export default navigationSlice.reducer;
